import React, { Suspense, useLayoutEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";

import ObservationListPage from "../pages/pre-built/observations/ObservationList";
import ObservationFormPage from "../pages/pre-built/observations/ObservationForm";
import ObservationViewPage from "../pages/pre-built/observations/ObservationView";
import { ObservationContextProvider } from "../pages/pre-built/observations/ObservationContext";

import WorkflowListPage from "../pages/pre-built/workflow/WorkflowList";
import WorkflowHistoryPage from "../pages/pre-built/workflow/WorkflowHistory";
import WorkflowDelayPredictionsPage from "../pages/pre-built/workflow/WorkflowDelayPredictions";
import UserManagementPage from "../pages/pre-built/users/UserManagement";
import RolePermissionManagement from "../pages/pre-built/users/RolePermissionManagement";
import UserSiteAssignment from "../pages/pre-built/users/UserSiteAssignment";
import ActivityLogHistory from "../pages/pre-built/users/ActivityLogHistory";
import CardOfMonthPage from "../pages/pre-built/card-of-month/CardOfMonth";
import ScoringConfigPage from "../pages/pre-built/card-of-month/ScoringConfigPage";
import NotificationsPage from "../pages/pre-built/notifications/NotificationsPage";
import AlertsCenterPage from "../pages/pre-built/alerts/AlertsCenterPage";
import GamificationPage from "../pages/pre-built/gamification/GamificationPage";
import CompliancePage from "../pages/pre-built/compliance/CompliancePage";
import ComplianceIntelligentAssistantPage from "../pages/pre-built/compliance/ComplianceIntelligentAssistantPage";
import RiskMappingPage from "../pages/pre-built/risk-mapping/RiskMappingPage";
import DashboardManagementPage from "../pages/pre-built/dashboard/DashboardManagement";
import HsePilotagePage from "../pages/pre-built/pilotage/HsePilotagePage";
import PredictiveAiPage from "../pages/pre-built/predictive-ai/PredictiveAiPage";
import SitesPage from "../pages/pre-built/sites/SitesPage";
import AnalyticsHSEPage from "../pages/pre-built/analytics/AnalyticsHSE";
import RiskScore7dPage from "../pages/pre-built/analytics/RiskScore7dPage";
import MonthlyReportsPage from "../pages/pre-built/reports/MonthlyReports";
import SiteReportsPage from "../pages/pre-built/reports/SiteReports";
import CustomReportsPage from "../pages/pre-built/reports/CustomReports";
import HseProcessInspectionsPage from "../pages/pre-built/hse-process/HseProcessInspectionsPage";
import HseProcessInspectionDetailPage from "../pages/pre-built/hse-process/HseProcessInspectionDetailPage";
import HseProcessPermitsPage from "../pages/pre-built/hse-process/HseProcessPermitsPage";
import HseProcessMocPage from "../pages/pre-built/hse-process/HseProcessMocPage";
import HseProcessIncidentsPage from "../pages/pre-built/hse-process/HseProcessIncidentsPage";
import HseProcessAssetsPage from "../pages/pre-built/hse-process/HseProcessAssetsPage";
import HseProcessOverviewPage from "../pages/pre-built/hse-process/HseProcessOverviewPage";
import DocumentationPage from "../pages/pre-built/documentation/DocumentationPage";

import Blank from "../pages/others/Blank";

const Pages = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Route exact path={`${process.env.PUBLIC_URL}/`} component={DashboardManagementPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-dashboard`} component={DashboardManagementPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-pilotage`} component={HsePilotagePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-predictive-ai`} component={PredictiveAiPage}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/dashboard-management`}
          render={() => <Redirect to={`${process.env.PUBLIC_URL}/hse-dashboard`} />}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/analytics`}
          render={() => <Redirect to={`${process.env.PUBLIC_URL}/analytics-hse`} />}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/_blank`} component={Blank}></Route>

        <Route
          exact
          path={`${process.env.PUBLIC_URL}/observations`}
          render={() => (
            <ObservationContextProvider>
              <ObservationListPage />
            </ObservationContextProvider>
          )}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/observations/new`} component={ObservationFormPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/observations/:id/edit`} component={ObservationFormPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/observations/:id/view`} component={ObservationViewPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/workflow/observations`} component={WorkflowListPage}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/workflow/pending`}
          render={() => <WorkflowListPage status="submitted" />}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/workflow/in-progress`}
          render={() => <WorkflowListPage status="in_analysis" />}
        ></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/workflow/closed`}
          render={() => <WorkflowListPage status="closed" />}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/workflow/history`} component={WorkflowHistoryPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/workflow/delay-predictions`} component={WorkflowDelayPredictionsPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/hse-process`} component={HseProcessOverviewPage}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/hse-process/inspections/:id`}
          component={HseProcessInspectionDetailPage}
        ></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-process/inspections`} component={HseProcessInspectionsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-process/permits`} component={HseProcessPermitsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-process/moc`} component={HseProcessMocPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-process/incidents`} component={HseProcessIncidentsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/hse-process/assets`} component={HseProcessAssetsPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/users/list`} component={UserManagementPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/users/roles`} component={RolePermissionManagement}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/users/sites`} component={UserSiteAssignment}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/users/audit`} component={ActivityLogHistory}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/card-of-month`} component={CardOfMonthPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/card-of-month/scoring-config`} component={ScoringConfigPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/notifications`} component={NotificationsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/alerts`} component={AlertsCenterPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/gamification`} component={GamificationPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/gamification/leaderboard`} component={GamificationPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/gamification/badges`} component={GamificationPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/gamification/points`} component={GamificationPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/gamification/sites`} component={GamificationPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/compliance/audit-trail`} component={CompliancePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/compliance/traceability`} component={CompliancePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/compliance/audit-reports`} component={CompliancePage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/compliance/iso`} component={CompliancePage}></Route>
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/compliance/intelligent-assistant`}
          component={ComplianceIntelligentAssistantPage}
        ></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/risk-mapping`} component={RiskMappingPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/sites`} component={SitesPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/analytics-hse`} component={AnalyticsHSEPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/analytics/risk-score-7d`} component={RiskScore7dPage}></Route>

        <Route exact path={`${process.env.PUBLIC_URL}/reports/monthly`} component={MonthlyReportsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/reports/sites`} component={SiteReportsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/reports/custom`} component={CustomReportsPage}></Route>
        <Route exact path={`${process.env.PUBLIC_URL}/documentation`} component={DocumentationPage}></Route>

        <Route component={RedirectAs404}></Route>
      </Switch>
    </Suspense>
  );
};

export default Pages;
